var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview",attrs:{"id":"app"}},[(_vm.pathRoute.indexOf('login') == -1)?_c('audioData'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }